import { ChangePasswordPayload, OtpRequiredResponse } from '@repo/user-types'
import { AxiosInstance, AxiosResponse } from 'axios'

export const changePassword = async ({
  api,
  params,
}: {
  api: AxiosInstance
  params: ChangePasswordPayload
}): Promise<AxiosResponse<OtpRequiredResponse>> => {
  return api.post<OtpRequiredResponse>('/user/change-password', params)
}
